export function extractField(data, getter) {
    if (typeof getter === 'function') {
        return getter(data);
    }
    return data[getter];
}
//# sourceMappingURL=ObjectUtils.js.map